export default "__VITE_ASSET__CMhLGQmp__"